import React ,{Component} from 'react';
import { NavLink,Navigate  } from 'react-router-dom';

import { styled } from '@mui/system';
import { Redirect  } from 'react-router-dom';
import Button from '@mui/material/Button';
import axios from 'axios';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table'; 
import TableContainer from '@mui/material/TableContainer';  
import TableRow from '@mui/material/TableRow';  
import TableHead from '@mui/material/TableHead';  
import TableCell from '@mui/material/TableCell'; 
import TableSortLabel from '@mui/material/TableSortLabel'; 
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';  
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import TableBody from '@mui/material/TableBody';
import TextField from '@mui/material/TextField';
import BusinessIcon from '@mui/icons-material/Business';
import DomainDisabledIcon from '@mui/icons-material/DomainDisabled';

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


const headCells = [

{ id: 'cmp_name', numeric: false,  label: 'Company' },
{ id: 'cpm_phone', numeric: false,  label: 'Mobile No.' },
{ id: 'cpm_email', numeric: false,  label: 'Email' },
{ id: 'cpm_state', numeric: false,  label: 'Province' },
{ id: 'cmp_co_id', numeric: false,  label: 'Country' },

{ id: '', numeric: false,  label: '' },

]

function EnhancedTableHead(props) {
  const {  order, orderBy,   onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };
  
  
return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = styled(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));


const EnhancedTableToolbar = props => {
const classes = useToolbarStyles();
const { numSelected } = props;

  
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = styled(theme =>({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
 
form: {
    width: '500%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  
})
)


export default class AdminCompany extends Component {
	constructor(props) {
    super();
this.state = {
logredirect:false,pagename:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:20,rowsPaging:[],
	 search:'',id:'',order:'desc' ,orderBy:'cmp_id',compdata:[],isblock:'',name:'',
	compemail:'',btndisabled:false,
submitbtn:"Submit",  
      }
	 };
	 
  myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});

 }



componentWillMount() {
		document.title = "Isifol - Company";
		if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            logredirect: true,
			pagename:'/AddCompany'
          })
		  }	  
	 this.props.parentdasCallback(
            "Manage Company~"
        );
 this.apicall(this.state.page,this.state.rowsPerPage);   
	}
	 	apicall(page,rowsPerPage){
 
  
  axios.get(localStorage.getItem("ISIurl")+'ajaxcompany.php?action=getall&cmp_name='+this.state.name+'&StartIndex='+page+'&PageSize='+rowsPerPage)
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  compdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			});
     }
	 else{
		   this.setState({compdata:[],totaldata:0});
	 }
   
    });

}

handleClickSearch=()=>{
 this.apicall(this.state.page,this.state.rowsPerPage); 
} 
handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};

handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
  
  
  
  blockunblockcomp(val,cmpid){
	 let strmsg="Unblock";
	 if(val===0)
	 {
		 strmsg="Block";
	 }
	 let r = window.confirm("Do you really want to "+strmsg+"?");
		 if(r == true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','blockorunblock')
					 formData.append('cmp_id',cmpid)
					 formData.append('cmp_isactive',val)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
					axios.post(localStorage.getItem("ISIurl")+"ajaxcompany.php", formData, {
						}).then(res => {
					
							this.apicall(this.state.page,this.state.rowsPerPage);
   
				  
					
					
							});
		 }
 
 } 
   deleteCompany(cmpid){  
  
		let r = window.confirm("Do you really want to Delete?");
		 if(r == true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','delete')					 
					 formData.append('cmp_id',cmpid)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
					  axios.post(localStorage.getItem("ISIurl")+"ajaxcompany.php", formData, {
						}).then(res => {
					
							this.apicall(this.state.page,this.state.rowsPerPage);
				  
					
					
							});
		 }
 }
 

 
 render() {
		if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
  return (
   <React.Fragment>
    <div className="searchbox">

<ul>


 <li>
        <p>Search</p>
        <p>
          <TextField
            variant="outlined"
            fullWidth
			className="txtbox"
            value={this.state.name}
            id="name"
            inputProps={{ tabIndex: "1", maxLength: 150 }}
            name="name"
            onChange={this.myChangeHandler}
            InputProps={{
              endAdornment: (
                <SearchOutlinedIcon style={{ marginLeft: 8 }} />
              ),
            }}
          />
        </p>
      </li>
		  
<li>
<p>&nbsp;</p>
	 <p className="searchbutton">
       <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
 
  Search 
</Button>
</p>
</li>
<li>
<p>&nbsp;</p><p> 
 <a  href='/#/Addcompany'> 
 <Button variant="contained" className="frmSecondarybtn" endIcon={<AddIcon />}>
    New
      </Button></a>
</p>
</li>
 </ul>
</div>
 <div className="clear"></div>


  
<Paper >
  <TableContainer >  
                <Table stickyHeader aria-label="sticky table">  

					  
					   <EnhancedTableHead
              
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.compdata.length}
            />
			
			
			
                      <TableBody>

                     {stableSort(this.state.compdata, getSorting(this.state.orderBy, this.state.order)).map((item,index) =>{
  return ( <React.Fragment>
 <TableRow key={index} >

	
	

<TableCell>{item.cmp_name}</TableCell>
<TableCell>{item.cmp_phone}</TableCell>
<TableCell>{item.cmp_email}</TableCell>
<TableCell>{item.cmp_state}</TableCell>
<TableCell>{item.co_name}</TableCell>

	
	
	
<TableCell align="left">
<a href={'/#/AddCompany?cmpid='+item.cmp_id}>
<Button variant="contained" className="frmSecondarybtn" endIcon={<EditIcon />}>
Edit
</Button></a>  

	&nbsp;
 <Button variant="contained" className="frmthirdbtn" onClick={()=>{this.deleteCompany(item.cmp_id)}} endIcon={<DeleteIcon />}>
Delete
</Button>&nbsp;
   {item.cmp_isactive === "0" && (
      <Button variant="contained" className="frmSecondarybtn" onClick={() => { this.blockunblockcomp(1,item.cmp_id) }} endIcon={<DomainDisabledIcon />}>
        Block
      </Button>
    )}
    {item.cmp_isactive === "1" && (
      <Button variant="contained" className="frmSecondarybtn" onClick={() => { this.blockunblockcomp(0,item.cmp_id) }} endIcon={<BusinessIcon />}>
        Unblock
      </Button>
    )}
 </TableCell>

 </TableRow>


				</React.Fragment>	
				);
				{this.state.totaldata===0 && (
					<TableRow  >
<TableCell colspan="5">
<h3>No Records</h3>
</TableCell>
				</TableRow>
				)}
				
			
					})}
                      </TableBody>


</Table>
  </TableContainer> 
 <TablePagination  
          rowsPerPageOptions={[50,100,200,300,400]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}    
      />    
  </Paper>
   
 

   
 </React.Fragment>

		  );
  }	
   
}